import { useCallback, useMemo, useState } from "react"
import { Input } from "../../Input/Input"
import debounce from 'lodash/debounce';

type Props = {
	disabled: boolean
	onChange(item: any): void
	useDebounce?: boolean
}

export const Filter = ({ disabled, onChange, useDebounce }: Props) => {
	const debounceDelay = useDebounce ? 500 : 0;

	const [value, setValue] = useState<string>();

	const setValueCallback = useCallback(
		(newValue: string | undefined) => {
			onChange(newValue);
		},
		[onChange]
	)

	const debounceSetValue = useMemo(
		() => debounce(setValueCallback, debounceDelay),
		[debounceDelay, setValueCallback]
	)

	const changeCallback = useCallback(
		(newValue: string | undefined) => {
			setValue(newValue);
			debounceSetValue(newValue);
		},
		[debounceSetValue]
	)

	if (disabled) {
		return <></>
	}

	return (
		<Input
			value={value}
			onChange={changeCallback}
			placeholder='i18n.label.search'
			// disabled={disabled}
			hideMaxLength
			focus
		/>
	)
}
